import { render, staticRenderFns } from "./TextDialogItem.vue?vue&type=template&id=1090aaaa&"
import script from "./TextDialogItem.vue?vue&type=script&lang=ts&"
export * from "./TextDialogItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports